import React from 'react';
import { useHistory } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import CommonButton from '@src/new-components/Button';
import Typography from '@src/new-components/Typography';
import ROUTES from '@src/constants/route';
import { ORDER_STATUS } from '@src/constants/order';
import { StyledAccumulation } from './index.style';

const TRANS_COMPONENTS = { hl: <span className="next-code-amount" /> };

const Stat = ({ icon, label, value, linkText, onLinkClick }) => (
  <div className="stat">
    <div className="icon-box">{icon}</div>
    <div className="stat-body">
      <Typography variant="body-14-regular" className="slate-text">
        {label}
      </Typography>
      <Typography variant="body-24-semibold" className="stat-value">
        {value}
      </Typography>
      <button type="button" className="stat-link" onClick={onLinkClick}>
        <Typography variant="body-12-regular">{linkText}</Typography>
        <ChevronRightRoundedIcon sx={{ fontSize: 14 }} />
      </button>
    </div>
  </div>
);

const AccumulationCard = ({
  config,
  isRunning,
  totalText,
  transactionCount,
  codeCount,
  amountToNextCode,
  formatMoney,
  onViewCodes,
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleViewTransactions = () =>
    history.push(ROUTES.PAYMENT_HISTORY, {
      paymentHistoryFilter: {
        packageStatus: ORDER_STATUS.PAID,
        createdAt: [new Date(config.startTime), new Date(config.endTime)],
      },
    });

  const codeCountText = codeCount > 0 ? String(codeCount).padStart(2, '0') : 0;
  const hasPaid = transactionCount > 0;

  return (
    <StyledAccumulation>
      <div className="stats-card">
        <Stat
          icon={<AccountBalanceWalletOutlinedIcon />}
          label={t('topPaidEventTotalAccumulation')}
          value={totalText}
          linkText={t('topPaidEventTransactionCount', {
            count: transactionCount,
          })}
          onLinkClick={handleViewTransactions}
        />
        <div className="stat-divider" />
        <Stat
          icon={<ConfirmationNumberOutlinedIcon />}
          label={t('topPaidEventRewardCodes')}
          value={t('topPaidEventCodeCount', {
            count: codeCount,
            display: codeCountText,
          })}
          linkText={t('topPaidEventViewList')}
          onLinkClick={onViewCodes}
        />
      </div>
      {isRunning && (
        <div className="next-code-strip">
          <Typography variant="body-16-regular" className="next-code-text">
            <Trans
              t={t}
              i18nKey={
                hasPaid
                  ? 'topPaidEventAmountToNextCode'
                  : 'topPaidEventAmountToFirstCode'
              }
              values={{ amount: formatMoney(amountToNextCode) }}
              components={TRANS_COMPONENTS}
            />
          </Typography>
          <CommonButton
            className="buy-more-button"
            onClick={() => history.push(ROUTES.PAYMENT)}
            textProps={{ variantText: 'body-14-medium' }}
          >
            {t(hasPaid ? 'buyMore' : 'buyNow')}
          </CommonButton>
        </div>
      )}
    </StyledAccumulation>
  );
};

export default AccumulationCard;
